import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  currUserDeptIdCache: -1,
  userDeptS: [],
}

const mutations = {

  setCurrUserDeptIdCache(state, deptId) {
    state.currUserDeptIdCache = deptId
  },

  findUserAllDept(state) {
    if (state.userDeptS.length !== 0) {
      return
    }
    let obj = {
      token: cookie.getCookie('token'),
      data:{
        reelect : true
      }
    }
    http.post(window.config.api.baseUrl + '/eims-api/user/userIdentity', obj).then(value => {
      if (value.data.code === '00000') {
        state.userDeptS = value.data.data.userDepartmentRole
      }
    })
  },

  setUserAllDept(state, obj) {
    state.userDeptS = obj
  }
}

const actions = {

  setUserAllDept: ({commit, state}, obj) => {
    commit('setUserAllDept',obj)
  },

  //查询部门的结果数据
  findUserAllDept: ({commit, state}, obj) => {
    commit('findUserAllDept')
  },
  //设置用户身份
  setCurrUserDeptIdCache: ({commit, state}, deptId) => {
    commit('setCurrUserDeptIdCache', deptId)
  },
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/headerStore.js